<template>
	<v-text-field
		style="height: 40px"
		:dense="true"
		:label="label"
		v-model="currentValue"
		@blur="update()"
		:error-messages="errorMessages"
		:disabled="readonly"
	>
	</v-text-field>
</template>

<script>
export default {
	props: {
		label: "",
		value: null,
		readonly: false,
		errorMessages: [],
	},

	data() {
		return {
			currentValue: "",
		};
	},

	mounted() {
		this.setInitialValue();
	},

	watch: {
		value() {
			this.setInitialValue();
		},
	},

	methods: {
		setInitialValue() {
			this.currentValue = (Math.round(this.value * 100) / 100).toFixed(2);
		},

		update() {
			if (!this.currentValue || this.currentValue.length === 0) {
				console.log(this.currentValue);
				this.$emit("valueChanged", null);
				return;
			}

			if (isNaN(this.currentValue)) {
				this.setInitialValue();
				return;
			}

			var numberValue = parseFloat(this.currentValue);
			numberValue = Math.round(numberValue * 100) / 100;
			if (Math.round(this.value * 100) / 100 !== numberValue) {
				this.$emit("valueChanged", numberValue);
			}
		},
	},
};
</script>

<style></style>
